import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const utimacoCircuitSwitchTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Utimaco Circuit Switch',
  key: 'utimacoCircuitSwitchTemplate',
  main: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          ['AFID', 'CFID', 'ISDN'],
          ['LEA', 'CCCMCID', 'CUGILC', '$empty'],
          ['CUGDNIC', 'CPRISDN', '$empty'],
          ['SS8ID']
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        initial: '',
        hide: 'true',
      },
      SS8ID: {
        label: 'ID',
        type: 'text',
        initial: '',
        hide: 'true',
        readOnly: true
      },
      ISDN: {
        label: 'ISDN Number',
        type: 'number',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 15,
            },
            {
              type: 'regexp',
              regexp: ['digits'],
              errorMessage: 'Can include digits. Please re-enter.',
            },
          ],
          required: true,
        },
      },
      CUGILC: {
        label: 'Interlock Code',
        type: 'text',
        initial: ''
      },
      CUGDNIC: {
        label: 'Data Network ID Code',
        type: 'text',
        initial: ''
      },
      AFID: {
        label: 'Access Function Name',
        type: 'select',
        initial: '',
        options: [],
        validation: {
          required: true,
        },
      },
      CFID: {
        label: 'Collection Function Name',
        type: 'select',
        initial: 'z1sdd',
        options: [],
        validation: {
          required: true,
        },
      },
      LEA: {
        label: 'LEA',
        type: 'select',
        initial: '',
        options: [
          {
            label: 'Select a value',
            value: ''
          }
        ],
        validation: {
          required: true,
        },
      },
      CPRISDN: {
        label: 'ISDN Number for COLP',
        type: 'text',
        initial: ''
      },

      CCCMCID: {
        label: 'Monitoring Center ID',
        type: 'text',
        initial: '',
        readOnly: true
      },
    },
  },
};
